import {
  FormItem,
  FormRadio,
  FormRadioGroup,
  NavigationModal
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type GenerateEventsModalProps = {
  showPrompt: boolean
  setShowPrompt: (showPrompt: boolean) => void
  confirmNavigation: (generateEvents: boolean) => void
}

const GenerateEventsModal = ({
  showPrompt,
  setShowPrompt,
  confirmNavigation
}: GenerateEventsModalProps) => {
  const { t } = useTranslation()

  const [generateEvents, setGenerateEvents] = useState(false)

  const handleConfirm = () => {
    confirmNavigation(generateEvents)
  }

  return (
    <NavigationModal
      modalTitle={t('GENERATING_EVENTS')}
      modalContentText={t('GENERATING_EVENTS_DESCRIPTION')}
      modalConfirmText={t('CONFIRM')}
      modalCancelText={t('CANCEL')}
      showPrompt={showPrompt}
      confirmNavigation={handleConfirm}
      cancelNavigation={() => setShowPrompt(false)}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <FormItem label={<Text>{t('SELECT_HOW_TO')}</Text>} long>
        <FormRadioGroup
          defaultValue={generateEvents}
          onChange={(e) => setGenerateEvents(e.target.value)}
        >
          <FormRadio value text={t('GENERATE')} />
          <FormRadio value={false} text={t('DO_NOT_GENERATE')} />
        </FormRadioGroup>
      </FormItem>
    </NavigationModal>
  )
}

export default GenerateEventsModal
